import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getPAAAA010lnb, putPAAAA010Banner, putPAAAA010ClickBanner } from '../../services/Api';
import { decodeToken } from '../../utils';
import { MENU_SIDENAV_DENTAL, MENU_SIDENAV_USER } from '../constants/app';
import ImageCheckFallback from './ImageCheckFallback';
const SideNav = () => {
    const navigate = useNavigate();
    const [dataLnb, setDataLnb] = useState([]);
    const login = useSelector(({ auth }) => auth.login);
    const location = useLocation();
    const decoded = login.token ? decodeToken(login.token) : null;
    const role = decoded?.authorities;
    const MENU = role === 'ROLE_C' ? MENU_SIDENAV_DENTAL : role === 'ROLE_P' ? MENU_SIDENAV_USER : [];
    const [isMenuVisible, setMenuVisible] = useState(false);

    const isActiveItem = (item) => {
        const hasInternalUrl = item?.internalUrl;
        const extractedUrl = location.pathname.split('-')[0];

        if (extractedUrl === item.url) {
            return true;
        } else if (hasInternalUrl && extractedUrl === hasInternalUrl[0]) {
            return true;
        } else if (item.child && item.child.some((childItem) => extractedUrl === childItem.url)) {
            return true;
        } else if (item.url === '/pajah010' && extractedUrl.startsWith('/pajah020')) {
            return true;
        } else if (item.url === '/pajab010' && extractedUrl.startsWith('/pajab020')) {
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        getPAAAA010lnb()
            .then(({ data }) => {
                setDataLnb(data.lnb);
                if (data.lnb?.length > 0) {
                    const listSeq = [data.lnb?.map((item) => item.seq).join(',')].filter((seq) => seq).join(',');
                    if (listSeq.toString() === '') return;
                    putPAAAA010Banner(listSeq.toString())
                        .then()
                        .catch((error) => console.log(error));
                }
            })
            .catch((error) => console.log(error));
    }, []);

    const toggleMenu = () => {
        setMenuVisible(!isMenuVisible);
    };

    const [openMenuIndex, setOpenMenuIndex] = useState(() => {
        const storedIndex = localStorage.getItem('activePopUpMenu');
        const parsedIndex = JSON.parse(storedIndex);
        if (typeof parsedIndex === 'number' || parsedIndex === null) {
            return parsedIndex;
        }
    });

    const handleMenuPopup = (item, index) => {
        localStorage.setItem('activePopUpMenu', index);
        if (item?.child) {
            setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
        } else {
            setOpenMenuIndex(null);
        }
        if (item.url || item.urlCommon) {
            navigate(item.url || item.urlCommon);
        }
    };

    const handleNavigation = (targetUrl, e) => {
        if (location.pathname === targetUrl) {
            window.location.reload();
        }
    };

    return (
        <>
            {/* Full screen overlay */}
            <div className={`full-screen-overlay ${isMenuVisible ? 'overlay-block' : ''}`} onClick={toggleMenu} />
            <div id="side-nav" className={isMenuVisible ? 'active' : ''}>
                <ul className="frame-section">
                    <Link
                        onClick={(e) => {
                            e.preventDefault();
                            toggleMenu();
                        }}
                        className={`${isMenuVisible ? 'active' : ''} close-menu-responsive`}
                    >
                        <i className="icon icon-hamburger-bar close" />
                    </Link>
                    {MENU.map((item, index) => (
                        <React.Fragment key={index}>
                            <li
                                className={`${openMenuIndex === index ? 'active-child' : ''} ${
                                    isActiveItem(item) ? 'active' : ''
                                }`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleMenuPopup(item, index);
                                    handleNavigation(item.url);
                                }}
                            >
                                <Link>
                                    <i className={item.icon} />
                                    {item.context}
                                </Link>
                            </li>
                        </React.Fragment>
                    ))}
                </ul>
                {dataLnb && (
                    <a
                        href={dataLnb[0]?.linkUrl}
                        rel="nofollow"
                        className="side-banner"
                        target={dataLnb[0]?.linkType === 'window' ? '_self' : dataLnb[0]?.linkType}
                        onClick={async (e) => {
                            if (dataLnb[0]?.linkType !== '_blank') {
                                e.preventDefault();
                            }
                            await putPAAAA010ClickBanner(dataLnb[0]?.seq);
                            try {
                                if (dataLnb[0]?.linkType === 'window') {
                                    window.open(
                                        dataLnb[0]?.linkUrl,
                                        '_blank',
                                        `width=${window.screen.width},height=${window.screen.height}`,
                                    );
                                } else if (dataLnb[0]?.linkType !== '_blank') {
                                    window.location.href = dataLnb[0]?.linkUrl;
                                }
                            } catch (error) {
                                console.log(error);
                            }
                        }}
                    >
                        <ImageCheckFallback
                            classImg={'topApds-img'}
                            folderName={'banner_photo_lnb'}
                            imgName={dataLnb[0]?.imgNameMain}
                        />
                    </a>
                )}
            </div>
        </>
    );
};
export default SideNav;
